import { Button } from '@globalmed/atlas-ui';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './NoOrganizationsScreen.module.css';
import { CreateOrganizationModal } from '@/features/CreateOrganizationModal';

/**
 * Empty-state screen shown to a super admin when no organizations exist yet.
 * The heading is rendered by TopPanel; this only holds the centered CTA.
 * @returns The no-organizations empty state
 */
export const NoOrganizationsScreen = () => {
  const { t } = useTranslation();
  const [isCreateOrganizationOpen, setIsCreateOrganizationOpen] =
    useState(false);

  return (
    <div className={styles.wrapper}>
      <Button
        variant="primary"
        preIcon="Plus"
        text={t('nav-panel.create-organization')}
        onClick={() => setIsCreateOrganizationOpen(true)}
      />
      <CreateOrganizationModal
        open={isCreateOrganizationOpen}
        setOpen={setIsCreateOrganizationOpen}
      />
    </div>
  );
};
